import { render, staticRenderFns } from "./bankAsideTotal.vue?vue&type=template&id=5452e916"
import script from "./bankAsideTotal.vue?vue&type=script&lang=js"
export * from "./bankAsideTotal.vue?vue&type=script&lang=js"
import style0 from "./bankAsideTotal.vue?vue&type=style&index=0&id=5452e916&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports